<template>
  <v-card flat>
    <app-patient-autocomplete
      data-e2e-id="create-edit-patient-id-input"
      :patients="filteredPatients"
      :selected-patient="patient"
      :patient-id-to-case-external-ids="patientIdToCaseExternalIds"
      :error-messages="patientIdErrors"
      @patientSearchChanged="updatePatients"
      @selectedPatientChange="$emit('changedSelectedPatient', $event)"
      @blur="$emit('blurredPatientExternalId')"
    />
    <v-text-field
      v-if="createNewPatient"
      v-model="patientFirstNameModel"
      data-e2e-id="create-case-patient-first-name-input"
      label="First Name"
      @input="$emit('input-patient-first-name', $event)"
    />
    <v-text-field
      v-if="createNewPatient"
      v-model="patientMiddleNameModel"
      label="Middle Name"
      @input="$emit('input-patient-middle-name', $event)"
    />
    <v-text-field
      v-if="createNewPatient"
      v-model="patientLastNameModel"
      data-e2e-id="create-case-patient-last-name-input"
      label="Last Name"
      @input="$emit('input-patient-last-name', $event)"
    />
    <v-card
      v-if="patientCaseExternalIds && patientCaseExternalIds.length > 0"
      flat
      class="text-left"
    >
      <v-card-text class="patient-case-title py-0">
        Associated Cases
      </v-card-text>
      <v-card-text v-for="externalId in patientCaseExternalIds" :key="externalId" class="py-0">
        {{ externalId }}
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import { patientService } from '@/services/patient-service'

export default {
  props: {
    patient: { type: Object, default: () => {} },
    patientFirstName: { type: String, default: '' },
    patientMiddleName: { type: String, default: '' },
    patientLastName: { type: String, default: '' },
    createNewPatient: { type: Boolean, default: false },
    orgId: { type: String, required: true },
    patientIdErrors: { type: Array, default: () => [] }
  },
  data() {
    return {
      filteredPatients: []
    }
  },
  computed: {
    ...mapState({
      cases: state => state.cases
    }),
    patientIdToCaseExternalIds() {
      return _.transform(
        this.cases,
        (result, patientCase) => {
          if (!result[patientCase.patient]) {
            result[patientCase.patient] = []
          }
          result[patientCase.patient] = _.union(result[patientCase.patient], [
            patientCase.externalId
          ])
        },
        {}
      )
    },
    patientFirstNameModel: {
      get() {
        return this.patientFirstName
      },
      set(name) {
        this.$emit('input-patient-first-name', name)
      }
    },
    patientMiddleNameModel: {
      get() {
        return this.patientMiddleName
      },
      set(name) {
        this.$emit('input-patient-middle-name', name)
      }
    },
    patientLastNameModel: {
      get() {
        return this.patientLastName
      },
      set(name) {
        this.$emit('input-patient-last-name', name)
      }
    },
    patientCaseExternalIds() {
      return this.patient && this.patient.id
        ? this.patientIdToCaseExternalIds[this.patient.id]
        : null
    }
  },
  methods: {
    async updatePatients(searchText) {
      if (_.isEmpty(searchText)) {
        this.filteredPatients = []
      } else {
        const params = {
          search: searchText,
          sortField: 'externalId',
          sortDirection: 'DESC'
        }

        const response = await patientService.get(this.orgId, params)
        this.filteredPatients = response.data.content
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.patient-case-title {
  font-size: 1rem;
  font-weight: bold;
}
</style>
